const LEGACY_TYPE_ALIASES = {
  cleaning: 'generalcleaning',
  contentsassessment: 'contentsinventoryassessment',
};

const canonical = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');

export const getJobTypeCommission = (commissionMap, jobType) => {
  if (!commissionMap || !jobType) return undefined;
  if (commissionMap[jobType] !== undefined) return commissionMap[jobType];

  const normalized = canonical(jobType);
  const matchingKey = Object.keys(commissionMap).find((key) => canonical(key) === normalized)
    || Object.keys(commissionMap).find((key) => canonical(key) === LEGACY_TYPE_ALIASES[normalized]);
  return matchingKey ? commissionMap[matchingKey] : undefined;
};